import { config } from '@services/config';
import { EnteredAddress } from '@models/validation';
import { fetchAddressSuggestions } from '@services/smarty/fetchAddressSuggestion';
import { isUnique } from '@services/smarty/isUnique';
import { useQuery } from '@tanstack/react-query';

export const useAddressSuggestions = (search: string, state?: string) => {
  const query = new URLSearchParams();
  if (search) {
    query.append('search', search);
  }
  if (state) {
    query.append('include_only_states', state);
  } else {
    query.append('include_only_states', 'ALLSTATES');
  }

  const result = useQuery<EnteredAddress[], Error>({
    queryKey: [
      'addressSuggestions',
      { search: query.get('search') || '', state: query.get('include_only_states') || '' },
    ],
    queryFn: async () => {
      const response = await fetchAddressSuggestions(query.toString());
      return response?.suggestions.map((s) => ({
        street1: s.street_line,
        city: s.city,
        state: s.state,
        zipCode: s.zipcode,
      }));
    },
    select: (data) => {
      const uniqueSuggestions: string[] = [];
      return data.filter((d) => isUnique(d, uniqueSuggestions));
    },
    enabled: !!search,
    ...config,
  });
  return { ...result, addressSuggestions: result.data || [] };
};
